import * as bus from "@sinch/bus";
import { getMfeConfig } from "./mfeConfig";

const unsub = bus.listen(async (message) => {
  if (bus.isData(message)) {
    const { name } = message.payload;
    const config = await getMfeConfig();
    const mfeConfig = config[name];

    if (mfeConfig && mfeConfig.url) {
      bus.sendLocal(
        bus.mfeConfigMessage({
          name,
          ...mfeConfig,
        })
      );
    } else {
      console.error(
        `Couldn't retrieve MFE info, ${name} not in Config or url is missing.`
      );
    }
  }
}, bus.isMfeConfigRequestMessage);

window.addEventListener("unload", unsub); // guess not needed actually
